import { useParams } from "react-router";

import { ActivityByEndpointV2 } from "../shared";

export const EndpointDetailActivityPage = () => {
  const { id = "" } = useParams();

  return <ActivityByEndpointV2 enpId={id} />;
};
